module.exports = __webpack_public_path__ + "statics/img/yhz_ios.c7fb23bc.png";